import React from "react";

const Footer = () => {
  return (
    <footer className="bg-alice text-space border-t border-violet py-6">
      <div className="flex flex-col items-center justify-center space-y-3">
        <a
          href="mailto:gregmcmahon313@gmail.com" // replace with your preferred email
          className="text-sm text-violet hover:text-space transition-colors duration-300"
        >
          gregmcmahon313@gmail.com
        </a>
        <p className="text-sm text-space/70">
          © {new Date().getFullYear()}. All rights reserved.
        </p>       
      </div>
    </footer>
  );
};

export default Footer;
